export const actionChangeHandelModalAddPGratuity = (statusShow) => ({
    type: 'CHANGE_HANDEL_MODAL_ADD_GRATUITY',statusShow
});
export const actionChangeInputsModalAddGratuity = (name,value) => ({
    type: 'CHANGE_INPUTS_MODAL_ADD_GRATUITY',name,value
});
